import React from 'react';
import { FormattedMessage, defineMessages } from 'react-intl';

import { Text } from '@atlaskit/primitives/compiled';

import { usePageSpaceKey } from '@confluence/page-context';
import { LiveDocsIconTile } from '@confluence/live-pages-features/entry-points/LiveDocsIconTile.ts';

import { buildCreationLink } from '../CreateContentRouteComponent/createContentRouteUtils.ts';
import { ConfluencePageSubType } from '../queries/__types__/CreateContentMutation.ts';

import { ContentTreeOnboardingItem, SOURCE_NAME } from './ContentTreeOnboardingItem.tsx';

const i18n = defineMessages({
	addYourFirstLiveDoc: {
		id: 'create-blank-fabric-page.content-tree-onboarding.new-live-doc',
		defaultMessage: 'Add your first live doc',
		description: 'Text shown in empty content tree which prompts user to create a new live doc.',
	},
});

export const CreateLiveDocOnboardingItem = () => {
	const [spaceKey] = usePageSpaceKey();

	const createLiveDocLink = buildCreationLink({
		contentType: 'page',
		subType: ConfluencePageSubType.LIVE,
		source: SOURCE_NAME,
		spaceKey,
	});

	return (
		<ContentTreeOnboardingItem
			href={createLiveDocLink}
			iconGlyph={<LiveDocsIconTile label="" size="medium" />}
			contentType="page"
			subType="live"
		>
			<Text maxLines={1} color="color.text.subtle">
				<FormattedMessage {...i18n.addYourFirstLiveDoc} />
			</Text>
		</ContentTreeOnboardingItem>
	);
};
